import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  complaintsList: [],
  isLoading: true,
  isPasswordLoading:true,
  isupdaterfeundLoading:true,
  complaintDetail: [],
  serviceOrdersList: [],
  serviceOrderDetail: [],
  purchaseOrderDetail: [],
  purifierOrdersList: [],
};

const complaintsSlice = createSlice({
  name: "Complaints",
  initialState,
  reducers: {
    setComplaintsList(state, actions) {
      state.complaintsList = actions.payload;
      state.isLoading = false;
    },
    fetchComplaintDetails(state, actions) {
      state.complaintDetail = actions.payload;
      state.isLoading = false;
    },
    setServiceOrdersList(state, actions) {
      state.serviceOrdersList = actions.payload;
      state.isLoading = false;
    },
    fetchServiceOrderDetails(state, actions) {
      state.serviceOrderDetail = actions.payload;
      state.isLoading = false;
    },
    fetchPurchaseOrderDetails(state, actions) {
      state.purchaseOrderDetail = actions.payload;
      state.isLoading = false;
    },
    setPurifierOrdersList(state, actions) {
      state.purifierOrdersList = actions.payload;
      state.isLoading = false;
    },
    
    

  },
});


export const { setComplaintsList, fetchComplaintDetails, setServiceOrdersList, fetchServiceOrderDetails, fetchPurchaseOrderDetails, setPurifierOrdersList }= complaintsSlice.actions;

const complaintsReducer = complaintsSlice.reducer;

export default complaintsReducer;
